import { render, staticRenderFns } from "./Statement.vue?vue&type=template&id=1a6f371e&"
import script from "./Statement.vue?vue&type=script&lang=ts&"
export * from "./Statement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports